import clsx from 'clsx';

type MobileMenuButtonProps = {
  isOpen: boolean;
  onClick: () => void;
};

export default function MobileMenuButton({ isOpen, onClick }: MobileMenuButtonProps) {
  return (
    <button className="lg:hidden flex flex-col justify-center items-center w-8 h-8 space-y-1" onClick={onClick}>
      <span
        className={clsx(
          'block w-6 h-0.5 bg-gray-600 transition-all duration-500 ease-in-out',
          isOpen ? 'rotate-45 translate-y-1.5' : ''
        )}
      ></span>
      <span
        className={clsx(
          'block w-6 h-0.5 bg-gray-600 transition-all duration-500 ease-in-out',
          isOpen ? 'opacity-0' : ''
        )}
      ></span>
      <span
        className={clsx(
          'block w-6 h-0.5 bg-gray-600 transition-all duration-500 ease-in-out',
          isOpen ? '-rotate-45 -translate-y-1.5' : ''
        )}
      ></span>
    </button>
  );
}
